export default __webpack_public_path__ + "static/media/bun-simt-mobile.e6e9fb74.png";